export class DashboardGraph {
    'id';
    'dashboardId';
    'title';
    'chartType';
    'sqlQuery';
    'columnMapping';
    'layout';
    'createdAt';
    'updatedAt';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "dashboardId",
            "baseName": "dashboardId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "chartType",
            "baseName": "chartType",
            "type": "DashboardGraphChartTypeEnum",
            "format": ""
        },
        {
            "name": "sqlQuery",
            "baseName": "sqlQuery",
            "type": "string",
            "format": ""
        },
        {
            "name": "columnMapping",
            "baseName": "columnMapping",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "layout",
            "baseName": "layout",
            "type": "DashboardGraphLayout",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return DashboardGraph.attributeTypeMap;
    }
    constructor() {
    }
}
export var DashboardGraphChartTypeEnum;
(function (DashboardGraphChartTypeEnum) {
    DashboardGraphChartTypeEnum["Bar"] = "BAR";
    DashboardGraphChartTypeEnum["Line"] = "LINE";
    DashboardGraphChartTypeEnum["Pie"] = "PIE";
    DashboardGraphChartTypeEnum["Area"] = "AREA";
    DashboardGraphChartTypeEnum["Scatter"] = "SCATTER";
    DashboardGraphChartTypeEnum["Donut"] = "DONUT";
    DashboardGraphChartTypeEnum["Table"] = "TABLE";
})(DashboardGraphChartTypeEnum || (DashboardGraphChartTypeEnum = {}));
